"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlledUploadFiles = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_component_library_1 = require("@esub-engineering/react-component-library");
var react_hook_form_1 = require("react-hook-form");
exports.ControlledUploadFiles = react_1.default.memo(function (_a) {
    var control = _a.control, name = _a.name;
    var _b = (0, react_hook_form_1.useController)({
        name: name,
        control: control,
    }).field, onChange = _b.onChange, defaultFiles = _b.value;
    return (0, jsx_runtime_1.jsx)(react_component_library_1.UploadFilesCarousel, { onChange: onChange, defaultFiles: defaultFiles });
});
